import React from "react";
import styled from "styled-components";
import { breakpoints, maxWidth } from "../../styles/variables";

const GridDiv = styled.div`
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;

  .image {
    width: 100%;
    height: 100%;
    overflow: hidden;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  > div:nth-of-type(1) {
    order: 2;
  }
  > div:nth-of-type(2) {
    order: 1;
  }
  > div:nth-of-type(3) {
    order: 4;
  }
  > div:nth-of-type(4) {
    order: 3;
  }
  > div:nth-of-type(5) {
    order: 6;
  }
  > div:nth-of-type(6) {
    order: 5;
  }
  > div:nth-of-type(7) {
    order: 8;
  }
  > div:nth-of-type(8) {
    order: 7;
  }
  > div:nth-of-type(9) {
    order: 10;
  }
  > div:nth-of-type(10) {
    order: 9;
  }
  > div:nth-of-type(11) {
    order: 12;
  }
  > div:nth-of-type(12) {
    order: 11;
  }
  > div:nth-of-type(13) {
    order: 14;
  }
  > div:nth-of-type(14) {
    order: 13;
  }
  > div:nth-of-type(15) {
    order: 16;
  }
  > div:nth-of-type(16) {
    order: 15;
  }
  > div:nth-of-type(17) {
    order: 18;
  }
  > div:nth-of-type(18) {
    order: 17;
  }
  > div:nth-of-type(19) {
    order: 20;
  }
  > div:nth-of-type(20) {
    order: 19;
  }

  @media screen AND (min-width: ${breakpoints.tablet}px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: ${maxWidth}px;
    margin: 0 auto;

    > * {
      min-height: 30vw;
    }

    > div:nth-of-type(1) {
      order: 1;
    }
    > div:nth-of-type(2) {
      order: 2;
    }
    > div:nth-of-type(3) {
      order: 4;
    }
    > div:nth-of-type(4) {
      order: 3;
    }
    > div:nth-of-type(5) {
      order: 5;
    }
    > div:nth-of-type(6) {
      order: 6;
    }
    > div:nth-of-type(7) {
      order: 8;
    }
    > div:nth-of-type(8) {
      order: 7;
    }
    > div:nth-of-type(9) {
      order: 9;
    }
    > div:nth-of-type(10) {
      order: 10;
    }
    > div:nth-of-type(11) {
      order: 12;
    }
    > div:nth-of-type(12) {
      order: 11;
    }
    > div:nth-of-type(13) {
      order: 13;
    }
    > div:nth-of-type(14) {
      order: 14;
    }
    > div:nth-of-type(15) {
      order: 16;
    }
    > div:nth-of-type(16) {
      order: 15;
    }
    > div:nth-of-type(17) {
      order: 17;
    }
    > div:nth-of-type(18) {
      order: 18;
    }
    > div:nth-of-type(19) {
      order: 20;
    }
    > div:nth-of-type(20) {
      order: 19;
    }

    .image {
      margin-bottom: 0;
    }
  }

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: ${maxWidth}px;
    margin: 0 auto;

    .image {
      margin-bottom: 0;
    }

    @media screen and (min-width: ${maxWidth}px) {
      grid-auto-rows: 576px;
    }
  }

  @media screen AND (min-width: 1920px) {
    > * {
      min-height: unset;
    }
  }
`;

const IconGrid: React.FC = ({ children }) => <GridDiv>{children}</GridDiv>;

export default IconGrid;
